import styled from "@emotion/styled";
import { colorPalette } from "../../../theme/colors";
import Box from "../../../primitives/Box/Box";

export const StyledImageContainer = styled(Box)`
  aspect-ratio: 1/1;
`;

export const StyledIcon = styled(Box)`
  transform: translate(-50%, -50%);
`;

export const StyledVideo = styled.video<{ isFullscreen: boolean }>`
  width: 100%;
  height: 100%;
  object-fit: ${(props) =>
    props.isFullscreen ? "contain" : "cover"} !important;
  border-radius: 4px;
  border: 1px solid ${colorPalette.popBlack[500]};

  /*iOS Safari specific fixes */
  -webkit-playsinline: true;
  playsinline: true;
  webkit-playsinline: true;

  /* Better video loading */
  preload: metadata;

  /*iOS Safari video controls */
  -webkit-media-controls: true;
  -webkit-media-controls-panel: true;
  -webkit-media-controls-play-button: true;
  -webkit-media-controls-start-playback-button: true;

  /* Force object-fit with !important for iOS Safari */
  -webkit-object-fit: ${(props) =>
    props.isFullscreen ? "contain" : "cover"} !important;
  -moz-object-fit: ${(props) =>
    props.isFullscreen ? "contain" : "cover"} !important;
  -ms-object-fit: ${(props) =>
    props.isFullscreen ? "contain" : "cover"} !important;

  /*iOS Safari specific video styling */
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;

  /* Force hardware acceleration for iOS */
  -webkit-perspective: 1000;
  perspective: 1000;
  -webkit-transform-style: preserve-3d;
  transform-style: preserve-3d;

  /* Force video to show first frame */
  background-color: ${colorPalette.popWhite[100]};

  /* iOS Safari specific fixes */
  -webkit-appearance: none;
  appearance: none;

  /* Ensure poster is displayed immediately */
  &[poster] {
    background-image: attr(poster);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
`;

export const StyledLink = styled.span`
  box-sizing: border-box;
  color: ${colorPalette.info[500]};
  cursor: pointer;
  display: inline-block;
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  letter-spacing: 0.2px;
  line-height: 18px; /* 150% */
  max-width: 100%;
  overflow-wrap: anywhere;
  text-decoration: underline;
  vertical-align: top;
  white-space: normal;
  word-break: break-word;
`;
